const theme = ({ palette: { common, form, secondary } }) => ({
  loadMore: {
    borderTop: `1px solid ${(form && form.border) || secondary.normal}`
  },
  footerBackground: common.white
  // Buttons from popup (click more/secondary actions) are outside of main root id / glu override syles
  // actionControl: {
  //   popover: {
  //     background: 'green',
  //   },
  // TODO: match grid background from web
  // drawerPanel: {
  //   background: 'green',
  // },
});

export default theme;
